import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8095";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  withCredentials: true,
  baseURL: API,
});

// If a session token is stored (fallback when cookies aren't available), apply
// it to the default Authorization header so requests include user context.
const storedToken = (() => {
  try {
    return window.localStorage.getItem("session_token");
  } catch {
    return null;
  }
})();
if (storedToken) {
  api.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
}
